import Vue from 'vue'

Vue.filter('secretPhoneNum', (value) => {
  if (value) {
    return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  } else {
    return null
  }
})



// WEBPACK FOOTER //
// ./src/filters/secret-tele.js